interface CheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Muted explanation under the label. */
  hint?: string;
  disabled?: boolean;
}

/** A labelled checkbox for settings — the whole row is clickable. */
export function Checkbox({ label, checked, onChange, hint, disabled = false }: CheckboxProps) {
  return (
    <label className="flex items-start gap-2 text-[13px] text-slate-700 cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-0.5 rounded border-slate-300 text-[#00A871] focus:ring-[#00A871]/30"
      />
      <span>
        {label}
        {hint && <span className="block text-[12px] text-slate-500">{hint}</span>}
      </span>
    </label>
  );
}
